import { render } from "./ButtonWhite.vue?vue&type=template&id=33c3aafc&scoped=true"
import script from "./ButtonWhite.vue?vue&type=script&lang=js"
export * from "./ButtonWhite.vue?vue&type=script&lang=js"

import "./ButtonWhite.vue?vue&type=style&index=0&id=33c3aafc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c3aafc"]])

export default __exports__